/**
 * Modèles de données des CGU.
 */
export class ConditionsGeneralesUtilisation {
    /**
     * Le contenu des conditions générales d'utilisation.
     */
    public contenu: string;

    constructor() {
        this.contenu = '';
    }
}
